import { render } from "./IppForm.vue?vue&type=template&id=26c9b66c"
import script from "./IppForm.vue?vue&type=script&lang=js"
export * from "./IppForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__